import request from '@/utils/request'

// 查询产品系列
export function queryList() {
  return request({
    url: 'app/technology/queryList',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/technology.js